import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.lg};
`;
export const Divider = styled.div `
  width: 100%;
  height: ${pxToRem(1)};
  background-color: ${theme.swatches.warm[100]};
`;
